<template>
  <div>
    <v-col cols="12" md="9" sm="12" class="mx-auto">
      <v-row justify="center">
        <v-col cols="12" md="3" sm="6">
          <DatePicker :label="`From`" @setDates="setFromDate" />
        </v-col>
        <v-col cols="12" md="3" sm="6" class="mt-n10 mt-md-0">
          <DatePicker :label="`To`" @setDates="setToDate" />
        </v-col>
        <v-col cols="6" md="2" sm="6" class="mt-md-4 mt-n10 mb-5 text-center">
          <v-btn
            class="pa-md-4 pa-2"
            small
            depressed
            color="success"
            @click="searchByDate"
          >
            Search
          </v-btn>
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-show="loader"
        :loading="loader"
        class="mb-3"
        type="list-item-avatar-two-line,table"
        elevation="2"
      />
      <v-data-table
        v-show="!loader"
        :headers="Headers"
        :items="loginHistory.loginData"
        :items-per-page="10"
        class="elevation-1"
        mobile-breakpoint="0"
        sort-by="updatedAt"
        :footerProps="footerProps"
      >
        <template v-slot:item.updatedAt="{ item }">
          <p>{{ item.updatedAt | dayFormat }}</p>
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState } from "vuex";
import DatePicker from "../datePicker.vue";
export default {
  name: "loginReportTable",
  components: { DatePicker },

  data() {
    return {
      fromDate: dayjs().subtract(7, "d").format("YYYY-MM-DD"),

      toDate: dayjs().format("YYYY-MM-DD"),

      // fromDate: '',
      // toDate: '',

      footerProps: {
        "items-per-page-options": [15, 30, 50, -1],
      },
      Headers: [
        { text: "Name", value: "userName", align: "center" },
        { text: "Email", value: "email", align: "center" },
        { text: "Date/Time", value: "updatedAt", align: "center" },
      ],
    };
  },

  created() {
    this.fetchUserLoginHistory();
  },

  computed: {
    ...mapState("userModule", ["loginHistory", "loader"]),
  },

  methods: {
    fetchUserLoginHistory() {
      let obj = {
        fromdate: this.fromDate,
        todate: this.toDate,
      };

      this.$store.dispatch("userModule/getUserLoginReport", obj);
    },

    setFromDate(date) {
      this.fromDate = date;
    },

    setToDate(date) {
      console.log(date);
      this.toDate = date;
    },

    searchByDate() {
      this.fetchUserLoginHistory();
    },
  },
};
</script>

<style></style>
